import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Welcome / start step of the Practice Setup wizard (Flutter tab 0).
 *
 * Mirrors Flutter `practice_setup_module/practice_setup/presentation/widgets/
 * practice_setup_start_widget.dart`. Greeting + body copy + single Start
 * button. The button fires the parent shell's `goNext` callback to
 * advance to tab 1 (Add Practice Details).
 *
 * Verbatim Flutter copy (preserve unless backend/i18n changes too):
 *   - "Hey {firstName}, Welcome to Scrips Practice Setup"
 *   - "Click start and we'll walk you through"
 *   - Button text: "Start"
 *
 * Per CLAUDE.md "Flutter-web workaround simplification rule": Flutter's
 * `ScripsIcons.reviewed` at size 80 in `successTabColor` (green) is the
 * decorative hero icon. React uses the lucide `CheckCircle2` for parity
 * without bundling a Flutter icon font.
 */
export interface WelcomeStepProps {
  firstName: string | null | undefined;
  onStart: () => void;
}

export function WelcomeStep({ firstName, onStart }: WelcomeStepProps) {
  return (
    <div className="flex h-full items-center justify-center px-8">
      <div className="flex max-w-[480px] flex-col items-center text-center">
        <CheckCircle2
          className="h-20 w-20 text-[var(--color-status-success)]"
          strokeWidth={1.5}
          aria-hidden
        />
        <div className="mt-8 [font:var(--type-card-title)] text-[var(--ink-body)]">
          Hey {firstName ?? 'there'},
        </div>
        <div className="[font:var(--type-card-title)] text-[var(--ink-body)]">
          Welcome to Scrips Practice Setup
        </div>
        <p className="mt-4 [font:var(--type-body)] text-[var(--ink-meta)]">
          Click start and we'll walk you through
        </p>
        <Button
          type="button"
          className="mt-8 h-12 w-[200px] text-md"
          onClick={onStart}
        >
          Start
        </Button>
      </div>
    </div>
  );
}
